import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    Lookup,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../../gridLayoutCustomization/GridLayoutManager";
const ChargeSearchFormResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "dc96adca-c885-497d-81b8-06753eff86a7";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className={props.searchPanelStatus ? "GridHeightAccordianOpen-tabs-single-row" : "GridHeightAccordianClose-tabs"}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="chargeCode" caption="Charge" dataType="string"></Column>
                <Column dataField="description_1" caption="Description" dataType="string"></Column>
                <Column dataField="description_2" caption="Description - 2" dataType="string"></Column>
                <Column dataField="customer" caption="Customer" dataType="string"></Column>
                <Column dataField="customerName" caption="Customer Name" dataType="string"></Column>
                <Column dataField="transactionType" caption="Transaction Type" dataType="string">
                    <Lookup
                        dataSource={[
                            { ID: "S", Text: "Shipment" },
                            { ID: "R", Text: "Receipt" },
                            { ID: "A", Text: "Adjustment" },
                            { ID: "C", Text: "Storage" },
                            { ID: "U", Text: "InBound" },
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="transactionNumber" caption="Transaction #" dataType="string"></Column>
                <Column dataField="amount" caption="Amount" format="$#,##0.00" dataType="number"></Column>
                <Column dataField="shipper" caption="Shipper" visible={false} dataType="string"></Column>
                <Column dataField="shipperName" caption="Shipper Name" visible={false} dataType="string"></Column>
                <Column dataField="consignee" caption="Consignee" visible={false} dataType="string"></Column>
                <Column dataField="consigneeName" caption="Consignee Name" visible={false} dataType="string"></Column>
                <Column dataField="shipperBolNumber" caption="Shippers #" visible={false} dataType="string"></Column>
                <Column dataField="status" caption="Status" visible={false} dataType="string">
                    <Lookup
                        dataSource={[
                            { ID: "O", Text: "Open" },
                            { ID: "H", Text: "Hold" },
                            { ID: "L", Text: "Commit Later" },
                            { ID: "N", Text: "Commit Now" },
                            { ID: "Z", Text: "Committed" },
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="stage" caption="Stage" visible={false} dataType="string">
                    <Lookup
                        dataSource={[
                            { ID: "P", Text: "Plan - No Inventory Effect, No Charges" },
                            { ID: "F", Text: "Future Order - No Effect On Net Available, No Charges" },
                            { ID: "N", Text: "Pending - Effects Net Available, No Charges" },
                            { ID: "R", Text: "Ready To Receive/Pick/Staged - Effects Available, No Charges" },
                            { ID: "C", Text: "Completed/Loaded/Put Away/Transferred/Adjusted - Effects Available, Yes, Charges" },
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="transactionDate" caption="Transaction Date" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="plannedReceivedShippedDateTime" caption="Planned" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="creationDateTime" caption="Creation Date" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="creationUserId" caption="Created By" visible={false} dataType="string"></Column>
                <Column dataField="lastUpdateDateTime" caption="Last Updated" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="lastUpdateUserId" caption="Last Updated By" visible={false} dataType="string"></Column>
                <Column dataField="actualReceivedShippedDateTime" caption="Recv/Ship Dt" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="equipmentInterchangeReport" caption="Trailer #/EIR" visible={false} dataType="string"></Column>
                <Column dataField="container" caption="Container #" visible={false} dataType="string"></Column>
                <Column dataField="reference" caption="Reference" visible={false} dataType="string"></Column>
                <Column dataField="transportationMode" caption="Mode" visible={false} dataType="string"></Column>
                <Column dataField="truckReference" caption="Truck/Driver" visible={false} dataType="string"></Column>
                <Column dataField="truckArrivalDateTime" caption="Truck Arrive" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="truckDepartDateTime" caption="Truck Depart" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="deliveryPickupPlannedDateTime" caption="Delv Planned" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="deliveryPickupArriveDateTime" caption="Actual Arrive" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="deliveryPickupDepartDateTime" caption="Actual Depart" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="dispatchOrderNumber" caption="Dispatch #" visible={false} dataType="string"></Column>
                <Column dataField="freightChargeType" caption="Freight Chg Type" visible={false} dataType="string">
                    <Lookup
                        dataSource={[
                            { ID: "P", Text: "Prepaid" },
                            { ID: "A", Text: "PrePaid - Add" },
                            { ID: "C", Text: "Collect" },
                            { ID: "D", Text: "COD" },
                            { ID: "B", Text: "Bill Third Party" },
                            { ID: "N", Text: "None" }
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="freightAmount" caption="Freight Amount" visible={false} format="$#,##0.00" dataType="number"></Column>
                <Column dataField="codAmount" caption="COD Amount" visible={false} format="$#,##0.00" dataType="number"></Column>
                <Column dataField="codCollectionDateTime" caption="COD Date" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="fiscalYear" caption="FY" visible={false} dataType="number"></Column>
                <Column dataField="fiscalPeriod" caption="FP" visible={false} dataType="number"></Column>
                <Column dataField="commitDate" caption="Commit Date" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="recordNumber" caption="Record # - Trans Charge" visible={false} dataType="string"></Column>
                <Column dataField="chargeType" caption="Charge Type" visible={false} dataType="string">
                    <Lookup
                        dataSource={[
                            { ID: "I", Text: "Item Chg" },
                            { ID: "T", Text: "Transaction Chg" },
                            { ID: "S", Text: "Storage Chg" },
                            { ID: "M", Text: "Miscellaneous Chg" }
                        ]}
                        displayExpr="Text"
                        valueExpr="ID"
                    />
                </Column>
                <Column dataField="billAs" caption="Bill As" visible={false} dataType="number"></Column>
                <Column dataField="rate" caption="Rate" visible={false} dataType="number"></Column>
                <Column dataField="fund" caption="Fund" visible={false} dataType="string"></Column>
                <Column dataField="fundDescription" caption="Fund Description" visible={false} dataType="string"></Column>
                <Column dataField="job" caption="Job" visible={false} dataType="string"></Column>
                <Column dataField="jobDescription" caption="Job Description" visible={false} dataType="string"></Column>
                <Column dataField="account" caption="Account" visible={false} dataType="string"></Column>
                <Column dataField="accountDescription" caption="Account Description" visible={false} dataType="string"></Column>
                <Column dataField="activity" caption="Activity" visible={false} dataType="string"></Column>
                <Column dataField="activityDescription" caption="Activity Description" visible={false} dataType="string"></Column>
                <Column dataField="department" caption="Department" visible={false} dataType="string"></Column>
                <Column dataField="departmentDescription" caption="Department Description" visible={false} dataType="string"></Column>

                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ChargeSearchFormResult);